export const datasetExists = dataType => (dataType.datasetsCount > 0) || (dataType.displayName === 'Generic');
